const parseEnvList = (value = '') =>
  value
    .split(',')
    .map(code => code.trim())
    .filter(Boolean)

export const TRADUCTOR_PRODUCTS = {
  FINANCIAL_CESSION: parseEnvList(
    process.env.TRADUCTOR_FINANCIAL_CESSION_PRODUCTS
  ),
  REQUIRE_PDF: parseEnvList(
    process.env.TRADUCTOR_REQUIRE_PDF_PRODUCTS
  )
}



// WEBPACK FOOTER //
// ./src/utils/traductorProducts.js